import styled from "styled-components";

export const StyledTableContainer = styled.div`
  margin: 0 0 1.5rem;
`;
